<template>
  <div class="eaAreaSurveyTemporary">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        <!-- 物业区域概况 -->
         维修资金余额概况
      </span>
      <!-- <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span> -->
    </div>
    <div class="container">
      <div class="box">
        <div class="AreaSurvey">

          <div class="charts">
            <div @click="forwordtoQueryOrganMge(2,1)" ref="eaarea" style="width:400px;height:250px"></div>
            <!-- <div
              @click="forwordtoQueryOrganMge(3,2)"
              ref="generalMeeting"
              style="width:210px;height:150px"
            ></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { HomePageExControllerSvr } from '@/service/HomePageExControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      areaProtoy: {},
      dataArray: []
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.HomePageExControllerSvr = new HomePageExControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.HomePageExControllerSvr.GetUseFunds(this.token).then(res => {
        for ( const {Funds: funds,CantonNmae: cantonNmae} of res) {
           this.dataArray.push({
             value: funds,
             name: cantonNmae, 
           })
        }

        this.drawVote(this.$refs.eaarea, '维修资金余额', this.dataArray, '#ffb11a');
        // });
      }, err => {
          this.$message({
            message: err,
            type: 'error'
          });
        });
    },
    forwordtoQueryOrganMge(value, type) {
      this.$router.push({
        path: 'queryOrganMge',
        query: {
          children: value,
          paramType: type
        }
      });
    },
    jumpMore() {
      this.$router.push({ path: 'queryPropertyArea' });
    },
    drawVote(dom, name, data, color, option) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      let partNum = 0;
      // info.CandidateItems._Items.forEach(item => {
      //   partNum += 1;
      // });
      //let percentage = Math.round(partNum / totlNum * 100) + '%';
      let percentage;
      if (parseInt(data[1]) >= 0 && parseInt(data[0]) >= 0) {
        if (parseInt(data[0]) === 0) {
          percentage = '0%';
        } else {
          percentage =
            (parseInt(data[1]) / parseInt(data[0]) * 100).toFixed(0) + '%';
        }
      } else {
        percentage = '0%';
      }

      //如果大于0不到1%的显示<1% 
          //         formatter: function (params, ticket, callback) {
          //     return `${params.seriesName} <br/>${params.name} : ${params.value}`
          // }
      if (
        parseInt(data[1]) / parseInt(data[0]) * 100 > 0 &&
        parseInt(data[1]) / parseInt(data[0]) * 100 < 1
      ) {
        percentage = '<'+'1%';
      }
      myChartSatisfaction.setOption({
        title : {
                text: '',
                subtext: '',
                x:'center'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
                series : [
                    {
                        name:'缴存金额',
                        type:'pie',
                        radius : '60%',
                        center: ['50%', '50%'],
                        data: data.sort(function (a, b) { return a.value - b.value; }),
                        roseType: 'radius',
                        label: {
                            normal: {
                                textStyle: {
                                    color: 'rgba(0,0,128, 0.3)'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                lineStyle: {
                                    color: 'rgba(0,0,128, 0.3)'
                                },
                                smooth: 0.2,
                                length: 10,
                                length2: 10
                            }
                        },
                        itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                        },

                        animationType: 'scale',
                        animationEasing: 'elasticOut',
                        animationDelay: function (idx) {
                            return Math.random() * 200;
                        }
                    }
                ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.eaAreaSurveyTemporary {
  background: #fff;
  .container {
    height: 260px;
    .box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .AreaSurvey {
        .title {
          position: relative;
          padding-left: 15px;
          font-size: 14px;
          &::after {
            position: absolute;
            left: 8px;
            top: 2px;
            content: '';
            width: 4px;
            height: 10px;
            background: #0f77f2;
          }
        }
        .info-text {
          display: flex;
          .info-first,
          .info-second {
            .text {
              margin-top: 10px;
              padding-left: 8px;
              padding-right: 2px;
              font-size: 12px;
              line-height: 14px;
              .num {
                font-size: 13px;
                font-weight: bold;
                color: #0f77f2;
                float: right;
                &.warn {
                  color: #ff4546;
                }
              }
              .cursor {
                cursor: pointer;
              }
            }
          }
          .info-first {
            width: 46%;
            .text {
              border-right: 1px solid #afafaf;
            }
          }
          .info-second {
            width: 54%;
            .text {
              padding-left: 8px;
              text-align: center
            }
          }
        }

        .charts {
          display: flex;
          justify-content: center;
          .typeTitle {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            min-width: 200px;
            justify-content: space-around;
            .fontSize {
              display: block;
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: -1px;
              color: #333333;
            }
            .num {
              margin-top: 6px;
              display: block;
              text-align: center;
              margin-right: 3px;
              &.warn {
                color: #ff4546;
              }
            }
          }
        }
        .compared {
          height: 230px;
          padding: 10px;
          .chartBox {
            // border-top: 1px solid #e2e2e2;
            padding-top: 10px;
            .tableInfo {
              margin-top: 12px;
              padding-left: 10px;
              display: flex;
              font-size: 12px;
              color: #333;
              .num {
                font-weight: bold;
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: #e2e2e2;
      }
    }
  }
}
</style>